export function toFlatRoomTypeSelectItem(item) {
  return {
    archived: item.deleted,
    label: item.value,
    position: item.position,
    value: item.id,
  }
}

export function toFlatRoomTypeSelectItems(data) {
  return data.map(toFlatRoomTypeSelectItem)
}
